<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.58337" y="1.75" width="8.5" height="8.5" rx="4.25" fill="#3C454D"/>
<rect x="1.58337" y="1.75" width="8.5" height="8.5" rx="4.25" stroke="#21282E" stroke-width="2.5"/>
</svg>
